export const featureIdMapping: {
  [key: string]: {
    featureId: string;
    flavorName: string;
    suitePath?: string;
    suiteUrl?: string;
  };
} = {
  develop: {
    featureId: '7051611331030433659',
    flavorName: 'Develop',
    suitePath: '/suite/develop',
  },
  teamwork: {
    featureId: '7497344015132535572',
    flavorName: 'Teamwork',
    suitePath: '/suite/teamwork',
  },
  ideas: { featureId: '7176377937479403267', flavorName: 'Ideas', suitePath: '/suite/ideas' },
  roadmap: {
    featureId: '7099078319733540170',
    flavorName: 'Roadmaps',
    suitePath: '/suite/roadmaps',
  },
  academy: {
    featureId: '7153332896823181858',
    flavorName: 'Academy',
    suiteUrl: 'https://www.aha.io/academy/certifications',
  },
  enterprise_plus: {
    featureId: '7148074887366420668',
    flavorName: 'Roadmaps E+',
    suitePath: '/suite/roadmaps/enterprise_plus',
  },
  whiteboards: {
    featureId: '7333230858416702915',
    flavorName: 'Whiteboards',
    suitePath: '/suite/whiteboards',
  },
  knowledge: {
    featureId: '7333230212709605344',
    flavorName: 'Knowledge',
    suitePath: '/suite/knowledge',
  },
  discovery: {
    featureId: '7475787212180571759',
    flavorName: 'Discovery',
    suitePath: '/suite/discovery',
  },
};

export function getFlavorDetails(upgradeLocation?: string) {
  // This naively assumes upgradeLocation begins with the promoted flavor name.
  // If the promotion button CTA or analytics events aren't working,
  // the upgradeLocation may need to be revised.

  const flavorMatch = Object.keys(featureIdMapping).find(flavor =>
    upgradeLocation?.startsWith(flavor),
  );
  if (flavorMatch) {
    return featureIdMapping[flavorMatch];
  }
}

export function handlePromoView(upgradeLocation: string, eventName?: string) {
  const flavorDetails = getFlavorDetails(upgradeLocation);

  if (flavorDetails && window.crossPromos) {
    const { featureId, flavorName } = flavorDetails;
    window.AhaAnalytics?.track(`Feature-${featureId}`, eventName || 'User views promotion', {
      'Upgrade location': window.crossPromos[upgradeLocation],
      'Promotion product': flavorName,
    });
  }
}

export function handleCtaClick(_event: MouseEvent, upgradeLocation: string, anchor?: string) {
  const flavorDetails = getFlavorDetails(upgradeLocation);
  if (flavorDetails && window.crossPromos) {
    const { featureId, flavorName, suitePath, suiteUrl } = flavorDetails;

    window.AhaAnalytics?.track(`Feature-${featureId}`, 'User clicks promotion', {
      'Upgrade location': window.crossPromos[upgradeLocation],
      'Promotion product': flavorName,
    });

    if (suiteUrl) {
      window.open(suiteUrl, '_blank', 'noopener noreferrer');
    } else {
      const url = `${suitePath}?upgrade_location=${upgradeLocation}${anchor ? `#${anchor}` : ''}`;
      window.open(url, '_blank', 'noopener noreferrer');
    }
  }
}
